import { useState } from "react";
import { Redirect } from "react-router-dom";
// import { identify, track } from "../../services/analytics";
import { authenticate, signIn } from "../../store/action/auth";
import { useTranslation } from "react-i18next";
import { Button, Card, Input } from "@biteship/atom";

export default function Example() {
  const { t } = useTranslation();
  const [values, setValues] = useState({
    email: "",
    password: "",
    error: "",
    loading: false,
    redirectToReferrer: false,
  });

  const { email, password, error, redirectToReferrer } = values;

  const onSubmit = () => {
    setValues({ ...values, error: false, loading: true });
    signIn({ email, password }).then((data) => {
      if (data.error) {
        setValues({ ...values, error: data.error, loading: false });
      } else {
        console.log(data);
        const user = {
          token: data.token,
          user: {
            _id: data.id,
            email: data.email,
            firstName: data.first_name,
            lastName: data.last_name,
            role: data.role,
            organizationName: data.organization_name,
            bankAccounts: data.bank_accounts,
            phone: data.phone,
            paymentStatus: data.payment_status,
            paymentDueDate: data.payment_due_date,
          },
        };

        // track('User Sign In', {
        //   action: 'track',
        //   category: 'Users',
        //   label: 'Sign In From Website',
        //   event: 'Click'
        // });

        authenticate(user, () => {
          // identify(user.user._id, user);
          setValues({
            ...values,
            redirectToReferrer: true,
            loading: false,
          });
        });
      }
    });
  };

  const showError = () => (
    <div className="alert alert-danger" style={{ display: error ? "" : "none" }}>
      {error}
    </div>
  );

  const redirectUser = () => {
    if (redirectToReferrer) {
      return <Redirect to="/overview" />;
    }
    return null;
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-xl px-8">
        <div className="flex justify-center">
          <img className="rounded" style={{ height: 72 }} src="/images/logos/biteship.png" alt="" />
        </div>
        <br />
        {showError()}
        {redirectUser()}
        <Card className="p-16 space-y-6" shadow>
          <div className="text-gray-900 font-bold text-2xl">Masuk ke akun Anda</div>
          <div className="space-y-6">
            <Input
              label="Email"
              name="email"
              onChange={(e) => setValues({ ...values, email: e.target.value })}
              placeholder={t("emailExample")}
              value={values.email}
            />
            <Input
              label="Password"
              name="password"
              onChange={(e) => setValues({ ...values, password: e.target.value })}
              type="password"
              placeholder={t("yourPassword")}
              value={values.password}
            />
            <Button
              className="w-full justify-center"
              title={t("button.signIn")}
              loading={values.loading}
              onClick={onSubmit}
            />
          </div>
        </Card>
        <div className="mt-4 text-gray-700">
          Belum punya akun?{" "}
          <text
            className="font-bold text-primary  cursor-pointer"
            onClick={() => window.location.assign("/signup")}
          >
            Daftar disini
          </text>
        </div>
        <div className=" text-gray-700">
          Lupa password?{" "}
          <text
            className="font-bold text-primary  cursor-pointer"
            onClick={() => window.location.assign("/forgot_password/new")}
          >
            Klik disini
          </text>
        </div>
      </div>
    </div>
  );
}
